import { render, staticRenderFns } from "./BKImage.vue?vue&type=template&id=105acd40&scoped=true"
import script from "./BKImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKImage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BKImage.vue?vue&type=style&index=0&id=105acd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105acd40",
  null
  
)

export default component.exports